import React from 'react';
import { spruceEventLabel } from '../logic/chatMessage';
import { timeAgo } from '../utils/formatTime';
import SpruceTranscript from './SpruceTranscript';

const ICON_PATHS = {
  spruce_call: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />,
  spruce_missed_call: <><path d="m23 1-6 6" /><path d="m17 1 6 6" /><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" /></>,
  spruce_voicemail: <><circle cx="5.5" cy="11.5" r="4.5" /><circle cx="18.5" cy="11.5" r="4.5" /><path d="M5.5 16h13" /></>,
};

// A clinic-line call, missed call or voicemail: a thin centred line, never a bubble, with its transcript under it.
// The wrapper is always there, so an opened transcript stays open across polls.
/** @param {{ entry: any, threadUrl?: string | null, transcript?: any }} props */
export default function SpruceCallRow({ entry, threadUrl = null, transcript = null }) {
  const label = spruceEventLabel(entry, 'staff');
  if (!label) return null;
  const missed = entry.msg_type === 'spruce_missed_call';
  const when = timeAgo(entry.sent_at);
  return (
    <div className="spruce-call">
      <div
        className="detail1"
        data-testid="spruce-call-row"
        style={{
          alignSelf: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          padding: '4px 12px',
          borderRadius: 999,
          background: 'var(--wi-background-secondary)',
          border: '1px solid var(--wi-divider)',
          color: missed ? 'var(--wi-text-primary-moderate)' : 'var(--wi-text-secondary)',
        }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          {ICON_PATHS[entry.msg_type]}
        </svg>
        <span style={{ fontWeight: 600 }}>{label}</span>
        <span aria-hidden="true">·</span>
        <span>{when}</span>
        {threadUrl && (entry.msg_type === 'spruce_voicemail' || (entry.msg_type === 'spruce_call' && transcript)) && (
          <>
            <span aria-hidden="true">·</span>
            <a href={threadUrl} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 600, color: 'var(--wi-action-primary)' }}>
              Open in Spruce to listen
            </a>
          </>
        )}
      </div>
      <SpruceTranscript transcript={transcript} when={when} noun={entry.msg_type === 'spruce_call' ? 'call' : 'voicemail'} />
    </div>
  );
}
